module.exports = __webpack_public_path__ + "img/HP-sec07-img-03.b94b1952.jpg";